import { lazy } from "react";

const routeLoaders = {
  coachLogin: () => import("./pages/CoachLogin"),
  dashboard: () => import("./pages/Dashboard"),
  clients: () => import("./pages/Clients"),
  coachAdaptations: () => import("./pages/CoachAdaptations"),
  clientDetail: () => import("./pages/ClientDetail"),
  workGroups: () => import("./pages/WorkGroups"),
  programs: () => import("./pages/Programs"),
  sessionBuilder: () => import("./pages/SessionBuilder"),
  sessionsLibrary: () => import("./pages/SessionsLibrary"),
  exercisesLibrary: () => import("./pages/ExercisesLibrary"),
  messages: () => import("./pages/Messages"),
  feedbackInbox: () => import("./pages/FeedbackInbox"),
  tests: () => import("./pages/Tests"),
  settings: () => import("./pages/Settings"),
  programmingAssistantProfile: () => import("./pages/ProgrammingAssistantProfile"),
  programmingAssistantNew: () => import("./pages/ProgrammingAssistantNew"),
  programDraftPreview: () => import("./pages/ProgramDraftPreview"),
  diagrams: () => import("./pages/DiagramsPage"),
  launchCalendar: () => import("./pages/LaunchCalendar"),
  subscribe: () => import("./pages/Subscribe"),
  subscriptionManagement: () => import("./pages/SubscriptionManagement"),
};

export const CoachLogin = lazy(routeLoaders.coachLogin);
export const Dashboard = lazy(routeLoaders.dashboard);
export const Clients = lazy(routeLoaders.clients);
export const CoachAdaptations = lazy(routeLoaders.coachAdaptations);
export const ClientDetail = lazy(routeLoaders.clientDetail);
export const WorkGroups = lazy(routeLoaders.workGroups);
export const Programs = lazy(routeLoaders.programs);
export const SessionBuilder = lazy(routeLoaders.sessionBuilder);
export const SessionsLibrary = lazy(routeLoaders.sessionsLibrary);
export const ExercisesLibrary = lazy(routeLoaders.exercisesLibrary);
export const Messages = lazy(routeLoaders.messages);
export const FeedbackInbox = lazy(routeLoaders.feedbackInbox);
export const Tests = lazy(routeLoaders.tests);
export const Settings = lazy(routeLoaders.settings);
export const ProgrammingAssistantProfile = lazy(routeLoaders.programmingAssistantProfile);
export const ProgrammingAssistantNew = lazy(routeLoaders.programmingAssistantNew);
export const ProgramDraftPreview = lazy(routeLoaders.programDraftPreview);
export const DiagramsPage = lazy(routeLoaders.diagrams);
export const LaunchCalendar = lazy(routeLoaders.launchCalendar);
export const Subscribe = lazy(routeLoaders.subscribe);
export const SubscriptionManagement = lazy(routeLoaders.subscriptionManagement);

export const preloadRoute = (name) => {
  const loader = routeLoaders[name];
  if (!loader) return;
  loader().catch(() => {});
};

export const preloadLikelyRoutes = () => {
  ["dashboard", "clients", "coachAdaptations", "workGroups", "programs", "messages", "feedbackInbox"].forEach((name) => {
    preloadRoute(name);
  });
};

export const routeLoaderMap = routeLoaders;
